import React, {
  Component,
} from 'react'

import {
  findDOMNode,
} from 'react-dom'

import Rx from 'rx-dom'

const easeInOutQuad = (t, b, c, d) => {
  t /= d / 2
  if (t < 1) return c/2*t*t + b // eslint-disable-line
  t -= 1
  return -c/2 * (t*(t-2) - 1) + b // eslint-disable-line
}

const scrollTo = (element, to, duration) => {
  let start = element.scrollTop
  let change = to - start
  let currentTime = 0
  let increment = 20

  let animateScroll = () => {
    currentTime += increment
    let val = easeInOutQuad(currentTime, start, change, duration)
    element.scrollTop = val
    if (currentTime < duration) {
      setTimeout(animateScroll, increment)
    }
  }
  animateScroll()
}

class ScrollTop extends Component {

  componentDidMount () {
    const element = findDOMNode(this)
    const source = Rx
    .DOM
    .click(element)

    source
      .subscribe(
      () => {
        scrollTo(document.body, 0, 1250)
      })
  }

  render () {
    return (
      <div id="scroll-top" className="display: block;">
        <i className="fa fa-angle-up" />
      </div>
    )
  }
}

export default ScrollTop



// WEBPACK FOOTER //
// ./src/containers/ScrollTop.js